import MiSurvivorPanel from './MiSurvivorPanel';
export default MiSurvivorPanel;